import React from 'react';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { STSNavItem } from './STSNavItem';
import { NavDivider } from './NavDivider';

export const N8NNav = () => {
  return (
    <>
      <STSNavItem
        icon={AutorenewIcon}
        text="Workflows"
        to="n8n/workflows"
      />
      <NavDivider color="#e0e0e0" />
    </>
  );
};
